import { FC, useMemo } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Container, Stack, useMediaQuery, useTheme } from '@mui/material';
import { userModel } from 'entities/user';
import { flexHelper, Icon, routes, useShallowSelector } from 'shared';

import { HeaderChainSelector, UserMenu } from './components';

export const Header: FC = () => {
  const { pathname } = useLocation();
  const { address } = useShallowSelector(userModel.selectors.selectUserWeb3Info);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const isConnectPage = useMemo(() => pathname === routes.connect.path, [pathname]);

  return (
    <Container sx={{ py: 1, ...flexHelper('space-between') }}>
      <NavLink to={routes.connect.path}>
        <Icon
          type={isSmallScreen ? 'logoSmall' : 'logo'}
          width={isSmallScreen ? 40 : 122}
          height={isSmallScreen ? 40 : 50}
        />
      </NavLink>
      {!isConnectPage && (
        <Stack direction="row" spacing={1}>
          {address && <HeaderChainSelector />}
          <UserMenu address={address} />
        </Stack>
      )}
    </Container>
  );
};
